// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:400,400i,700,900);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
* This is the login page stylesheet.
* @author  Bharat Gogineni <bharat@vantageagora.com>
*/
html {
  height: 100%;
  overflow: hidden;
}

body {
  height: 100%;
  margin: 0;
}
body.login {
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.57;
  color: #545456;
  background-color: transparent;
}
body img#ox-logo {
  width: 90%;
  height: auto;
  max-height: 130px;
  object-fit: contain;
}
body .reactLoginPage {
  height: 100%;
  display: flex;
}
body .loginContainer {
  width: 100%;
  height: 100%;
  margin: 0 !important;
  display: flex !important;
  flex-direction: row;
}
body #login-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
body #ox-logo {
  width: 100%;
  height: auto;
}
body .ox-imgDiv {
  text-align: center;
  margin: 20px;
}
body #ox-login-form,
body #ox-forgotpassword-form {
  position: relative;
  background: rgba(255, 255, 255, 0.8);
  flex-flow: column;
  flex-grow: 3;
  display: flex;
  flex-direction: column;
  min-width: 300px;
  min-height: 50vh;
  height: 100%;
}
body #ox-login-form .form-wrapper__inner,
body #ox-forgotpassword-form .form-wrapper__inner {
  height: inherit;
}
body #ox-login-form a:hover,
body #ox-forgotpassword-form a:hover {
  cursor: pointer;
}
body #ox-login-form .ox-form,
body #ox-forgotpassword-form .ox-form {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
  height: inherit;
}
body #ox-login-form .ox-form-wrapper,
body #ox-forgotpassword-form .ox-form-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
body #ox-login-form .ox-form-wrapper .loginAction,
body #ox-forgotpassword-form .ox-form-wrapper .loginAction {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  width: 100%;
}
body #ox-login-form .osjs-login-error,
body #ox-forgotpassword-form .osjs-login-error {
  background-color: #ffebee;
  color: #c62828;
  padding: 1rem;
  border-radius: 4px;
  margin: 1rem 0;
}
body #ox-login-form .ox-form.forgot-password,
body #ox-forgotpassword-form .ox-form.forgot-password {
  padding: 20px;
}
body #ox-login-form .coppyRight,
body #ox-forgotpassword-form .coppyRight {
  text-align: center;
}
body #ox-login-form h4,
body #ox-forgotpassword-form h4 {
  margin-bottom: 20px;
  color: rgba(0, 0, 0, 0.5);
}
body #ox-login-form h4 span,
body #ox-forgotpassword-form h4 span {
  color: #000;
  font-weight: 700;
}
body #ox-login-form p,
body #ox-forgotpassword-form p {
  line-height: 155%;
  margin-bottom: 40px;
  font-size: 14px;
  color: #000;
  opacity: 0.65;
  font-weight: 400;
  max-width: 200px;
}
body #ox-login-form a.discrete,
body #ox-forgotpassword-form a.discrete {
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  border-bottom: solid 1px transparent;
  padding-bottom: 4px;
  margin-left: auto;
  font-weight: 300;
  transition: all 0.3s ease;
  margin-top: 40px;
}
body #ox-login-form a.discrete:hover,
body #ox-forgotpassword-form a.discrete:hover {
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);
}
body #ox-login-form input,
body #ox-forgotpassword-form input {
  font-size: 16px;
  letter-spacing: 0.6px;
  height: 56px;
  border: none;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
  transition: all 0.3s linear;
  background: transparent;
  color: #000;
  font-weight: 400;
  -webkit-appearance: none;
}
body #ox-login-form input:focus,
body #ox-forgotpassword-form input:focus {
  border-bottom: solid 1px #275362;
  outline: 0;
  box-shadow: 0 2px 6px -8px rgba(182, 157, 230, 0.45);
}
body #ox-login-form button,
body #ox-forgotpassword-form button {
  -webkit-appearance: none;
  width: 100%;
  max-width: 250px;
  min-width: 100px;
  border-radius: 0.25em;
  text-align: center;
  padding: 20px 40px;
  margin: 10px 0;
  background-color: #275362;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 2px 6px -1px rgba(0, 0, 0, 0.13);
  border: none;
  transition: all 0.3s ease;
  outline: 0;
  cursor: pointer;
}
body #ox-login-form button:hover,
body #ox-forgotpassword-form button:hover {
  transform: translateY(-3px);
  box-shadow: 0 2px 6px -1px rgba(182, 157, 230, 0.65);
}
body #ox-login-form button:hover:active,
body #ox-forgotpassword-form button:hover:active {
  transform: scale(0.99);
}
body #ox-forgotpassword-form {
  flex-grow: 0;
  justify-content: space-between;
  padding: 0;
  padding-bottom: 20px;
  height: auto;
}
body .form-signin__footer {
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: column;
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 15px;
}
body .form-signin__footer button {
  margin: 10px 0;
}
body .form-signin__footer a {
  margin: 15px 0;
  color: #275362;
  text-decoration: none;
}
body .form-signin__footer a:hover {
  text-decoration: underline;
}
body .floating-label {
  position: relative;
  margin-bottom: 10px;
  width: 100%;
  padding: -5 px;
}
body .form-filler {
  width: 100;
  height: 120px;
}
body .footer-CR {
  color: white;
}
body .login .input-field > label {
  user-select: none;
}
body .login-copyright {
  font-size: 12px;
  color: #b3b3b3;
  text-align: center;
  padding: 0 16px;
}
body #footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px;
  z-index: 10;
  background-color: #452767;
}
body .coppyRight {
  color: #275362;
  justify-content: center;
}
body .osjs-login-error {
  color: #ff2b00;
  min-height: 24px;
  font-size: 13px;
  line-height: 1.23;
  text-shadow: none;
  position: relative;
  padding: 4px;
  margin-bottom: 1rem;
}
@media screen and (max-width: 900px) {
  body #ox-login-form {
    text-align: center;
    position: relative;
    margin: 0px;
    overflow: auto;
    flex: 0 0 100%;
    max-width: 500px;
  }
  body .form-wrapper__inner {
    padding: 30px;
  }
  body .ox-imgDiv {
    margin-bottom: 30px;
  }
  body .loginSlider {
    display: none !important;
  }
  body .loginContainer {
    flex-direction: column;
    align-items: center;
  }
}
body .tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
body .tooltip .tooltiptext {
  visibility: hidden;
  position: absolute;
  width: 350px;
  background-color: #555;
  color: #fff;
  text-align: left;
  padding: 5px 5px;
  border-radius: 6px;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.6s;
  right: 10%;
  top: -100%;
}
body .tooltip-left {
  top: -5px;
  bottom: auto;
  right: 128%;
}
body .resetPasswordInputField {
  display: inline-flex;
}
body .resetPasswordInputField .newPasswordDiv {
  display: inline;
  width: 100%;
}
body .resetPasswordInputField .infoDiv {
  display: inline;
  width: 10%;
  margin: auto;
  border-bottom: none;
  position: relative;
}
body .passwordRestInfoIcon {
  color: #fff;
  font-size: 1.5em;
  border-radius: 10px;
  background-color: #275362;
}
body .footer {
  position: absolute;
  display: flex;
  bottom: 30px;
  width: 100%;
  flex-direction: column;
}
body .footer-links {
  text-align: center;
}
body .login-copyright {
  font-size: 12px;
  color: #b3b3b3;
  text-align: center;
  padding: 0 16px;
}
body a.footer-link {
  color: #275362;
  text-decoration: dashed;
}
body a.forgotpasswordLink {
  margin: 15px;
  color: #275362;
  border-bottom: 1px dotted #275362;
  text-decoration: none;
}
body .Announcement-visuals {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #edf3f2;
  width: 100% !important;
  position: absolute !important;
  top: 0;
}
body .Announcement-visuals img {
  width: auto;
  height: auto;
  max-width: 100%;
}
body .announcement-slider {
  position: relative;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
}
body .slider-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 10;
}
body .slide {
  position: unset;
  display: inline-block;
  height: 100%;
  width: 100%;
}
body .arrowWrap {
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  top: 0;
  position: absolute;
}
body .arrowWrap .arrow {
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: transform ease-in 0.1s;
  opacity: 0.3;
}
body .arrowWrap .arrow:hover {
  opacity: 1;
  background-color: #fff;
}
body .arrowWrap .backArrow,
body .arrowWrap .nextArrow {
  z-index: 100;
  color: gray;
  opacity: 0.3;
  background-color: #fff;
}
body .arrowWrap .backArrow {
  margin-left: 1%;
}
body .arrowWrap .nextArrow {
  margin-right: 1%;
}
body .tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
body .tooltip .tooltiptext {
  visibility: hidden;
  position: absolute;
  width: 350px;
  background-color: #555;
  color: #fff;
  text-align: left;
  padding: 5px;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.6s;
  right: 10%;
  top: -100%;
}
@keyframes shake-shake {
  0% {
    transform: translateX(-3px);
  }
  20% {
    transform: translateX(3px);
  }
  40% {
    transform: translateX(-3px);
  }
  60% {
    transform: translateX(3px);
  }
  80% {
    transform: translateX(-3px);
  }
  100% {
    transform: translateX(0);
  }
}
@media screen and (max-width: 900px) {
  body #ox-login-form {
    text-align: center;
    position: relative;
    margin: 0;
    overflow: auto;
    flex: 0 0 100%;
    max-width: 500px;
  }
  body .form-wrapper__inner {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 30px;
  }
  body .loginSlider {
    display: none !important;
  }
  body .loginContainer {
    flex-direction: column;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/client/assets/scss/login.scss"],"names":[],"mappings":"AAAA;;;CAAA;AAoBA;EACE,YAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,YAAA;EACA,SAAA;AAdF;AAgBE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cA1BS;EA2BT,6BAAA;AAdJ;AAgBA;EACI,UAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAdJ;AAkBA;EACE,YAAA;EACA,aAAA;AAhBF;AAmBA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,wBAAA;EACA,mBAAA;AAjBF;AAoBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AAlBF;AAsBA;EACE,WAAA;EACA,YAAA;AApBF;AAuBA;EACE,kBAAA;EACA,YAAA;AArBF;AA0BA;;EAEE,kBAAA;EACA,oCAAA;EACF,iBAAA;EACE,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAzBF;AA2BE;;EACE,eAAA;AAxBJ;AA4BI;;EACE,eAAA;AAzBN;AA6BE;;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;AA1BJ;AA6BE;;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AA1BJ;AA6BI;;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AA1BN;AA8BE;;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AA3BJ;AA8BE;;EACE,aAAA;AA3BJ;AA8BE;;EACE,kBAAA;AA3BJ;AA8BE;;EACE,mBAAA;EACA,yBAAA;AA3BJ;AA6BI;;EACE,WAzIE;EA0IF,gBAAA;AA1BN;AA8BE;;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAlJI;EAmJJ,aAAA;EACA,gBAAA;EACA,gBAAA;AA3BJ;AA8BE;;EACE,yBAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AA3BJ;AA6BI;;EACE,2CAAA;AA1BN;AA8BE;;EACE,eAAA;EAEA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,WAlLI;EAmLJ,gBAAA;EACA,wBAAA;AA5BJ;AA8BI;;EACE,gCAAA;EACA,UAAA;EACA,oDAAA;AA3BN;AA+BE;;EACE,wBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBA1MW;EA2MX,WAxMI;EAyMJ,eAAA;EACA,gBAAA;EACA,8CAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;AA5BJ;AA8BI;;EACE,2BAAA;EACA,oDAAA;AA3BN;AA6BM;;EACE,sBAAA;AA1BR;AAgCA;EACE,YAAA;EACA,8BAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;AA9BF;AAiCA;EACE,8BAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA/BF;AAkCE;EACE,cAAA;AAhCJ;AAmCE;EACE,cAAA;EACA,cAvPW;EAwPX,qBAAA;AAjCJ;AAmCI;EACE,0BAAA;AAjCN;AAuCA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AArCF;AAwCA;EACE,UAAA;EACA,aAAA;AAtCF;AAyCA;EACE,YAAA;AAvCF;AAyCA;EACE,iBAAA;AAvCF;AA0CA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAxCF;AA2CA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;AAzCF;AA4CA;EACE,cAAA;EACA,uBAAA;AA1CF;AA6CA;EAEE,cAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AA7CF;AAkDA;EACE;IACE,kBAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;IACA,cAAA;IACA,gBAAA;EAhDF;EAkDA;IACE,aAAA;EAhDF;EAkDA;IACE,mBAAA;EAhDF;EAkDA;IACE,wBAAA;EAhDF;EAqDA;IAEE,sBAAA;IACA,mBAAA;EApDF;AACF;AAuDA;EACE,mBAAA;EACA,UAAA;AArDF;AAuDA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;EACA,UAAA;EACA,UAAA;AArDF;AAuDA;EACE,SAAA;EACA,YAAA;EACA,WAAA;AArDF;AAwDA;EACE,oBAAA;AAtDF;AAwDE;EACE,eAAA;EACA,WAAA;AAtDJ;AAyDE;EACE,eAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAvDJ;AA2DA;EACE,WA5XM;EA6XN,gBAAA;EACA,mBAAA;EACA,yBAlYa;AAyUf;AA6DA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AA3DF;AA8DA;EAEE,kBAAA;AA7DF;AAoEA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAlEF;AAuEE;EACE,cAjaW;EAkaX,uBAAA;AArEJ;AAwEE;EACE,YAAA;EACA,cAvaW;EAwaX,iCAAA;EACA,qBAAA;AAtEJ;AA2EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;EACA,MAAA;AAzEF;AA2EE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAzEJ;AA8EA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AA5EF;AA+EA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AA7EF;AAgFA;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AA9EF;AAkFA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,MAAA;EACA,kBAAA;AAhFF;AAkFE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AAhFJ;AAkFI;EACE,UAAA;EACA,sBA5eE;AA4ZR;AAoFE;;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBArfI;AAmaR;AAqFE;EACE,eAAA;AAnFJ;AAsFE;EACE,gBAAA;AApFJ;AA0FE;EACE,mBAAA;EACA,UAAA;AAxFJ;AA2FE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAzgBS;EA0gBT,WA7gBI;EA8gBJ,gBAAA;EACA,YAAA;EACA,kBAAA;EAEA,UAAA;EACA,wBAAA;EACA,UAAA;EACA,UAAA;AA1FJ;AA+FA;EACE;IACE,2BAAA;EA7FF;EAgGA;IACE,0BAAA;EA9FF;EAiGA;IACE,2BAAA;EA/FF;EAkGA;IACE,0BAAA;EAhGF;EAmGA;IACE,2BAAA;EAjGF;EAoGA;IACE,wBAAA;EAlGF;AACF;AAsGA;EACE;IACE,kBAAA;IACA,kBAAA;IACA,SAAA;IACA,cAAA;IACA,cAAA;IACA,gBAAA;EApGF;EAuGA;IACE,aAAA;IACA,sBAAA;IACA,6BAAA;IACA,aAAA;EArGF;EA4GA;IACE,wBAAA;EA1GF;EA6GA;IACE,sBAAA;IACA,mBAAA;EA3GF;AACF","sourcesContent":["/*!\r\n* This is the login page stylesheet.\r\n* @author  Bharat Gogineni <bharat@vantageagora.com>\r\n*/\r\n\r\n// Variables\r\n$primary: rgb(182, 157, 230);\r\n$button-color: #275362;\r\n$text-color: #545456;\r\n$border-color: rgba(0, 0, 0, 0.1);\r\n$white: #fff;\r\n$black: #000;\r\n$error-color: #ff2b00;\r\n$tooltip-bg: #555;\r\n$displacement: 3px;\r\n\r\n// Imports\r\n@import url('https://fonts.googleapis.com/css?family=Lato:400,400i,700,900');\r\n\r\n// Base styles\r\nhtml {\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\nbody {\r\n  height: 100%;\r\n  margin: 0;\r\n\r\n  &.login {\r\n    font-family: 'Lato', sans-serif;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 1.57;\r\n    color: $text-color;\r\n    background-color: transparent;\r\n}\r\nimg#ox-logo {\r\n    width: 90%;\r\n    height: auto;\r\n    max-height: 130px;\r\n    object-fit: contain;\r\n}\r\n\r\n// Layout components\r\n.reactLoginPage {\r\n  height: 100%;\r\n  display: flex;\r\n}\r\n\r\n.loginContainer {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0 !important;\r\n  display: flex !important;\r\n  flex-direction: row;\r\n}\r\n\r\n#login-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n// Logo and branding\r\n#ox-logo {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.ox-imgDiv {\r\n  text-align: center;\r\n  margin: 20px;\r\n}\r\n\r\n// Form styles\r\n\r\n#ox-login-form,\r\n#ox-forgotpassword-form {\r\n  position: relative;\r\n  background: rgba($white, 0.8);\r\nflex-flow: column;\r\n  flex-grow: 3;\r\n  // padding: 40px 30px 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 300px;\r\n  min-height: 50vh;\r\n  height: 100%;\r\n\r\n  .form-wrapper__inner {\r\n    height: inherit;\r\n  }\r\n\r\n  a {\r\n    &:hover {\r\n      cursor: pointer;\r\n    }\r\n  }\r\n\r\n  .ox-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    justify-content: space-between;\r\n    height: inherit;\r\n  }\r\n\r\n  .ox-form-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    // gap: 20px;\r\n\r\n    .loginAction {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 10px;\r\n      align-items: center;\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .osjs-login-error {\r\n    background-color: #ffebee;\r\n    color: #c62828;\r\n    padding: 1rem;\r\n    border-radius: 4px;\r\n    margin: 1rem 0;\r\n  }\r\n\r\n  .ox-form.forgot-password {\r\n    padding: 20px;\r\n  }\r\n\r\n  .coppyRight {\r\n    text-align: center;\r\n  }\r\n\r\n  h4 {\r\n    margin-bottom: 20px;\r\n    color: rgba($black, 0.5);\r\n\r\n    span {\r\n      color: $black;\r\n      font-weight: 700;\r\n    }\r\n  }\r\n\r\n  p {\r\n    line-height: 155%;\r\n    margin-bottom: 40px;\r\n    font-size: 14px;\r\n    color: $black;\r\n    opacity: 0.65;\r\n    font-weight: 400;\r\n    max-width: 200px;\r\n  }\r\n\r\n  a.discrete {\r\n    color: rgba($black, 0.4);\r\n    font-size: 14px;\r\n    border-bottom: solid 1px transparent;\r\n    padding-bottom: 4px;\r\n    margin-left: auto;\r\n    font-weight: 300;\r\n    transition: all 0.3s ease;\r\n    margin-top: 40px;\r\n\r\n    &:hover {\r\n      border-bottom: solid 1px rgba($black, 0.2);\r\n    }\r\n  }\r\n\r\n  input {\r\n    font-size: 16px;\r\n    // padding: 15px 10px;\r\n    letter-spacing: 0.6px;\r\n    height: 56px;\r\n    border: none;\r\n    border-bottom: solid 1px $border-color;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    transition: all 0.3s linear;\r\n    background: transparent;\r\n    color: $black;\r\n    font-weight: 400;\r\n    -webkit-appearance: none;\r\n\r\n    &:focus {\r\n      border-bottom: solid 1px $button-color;\r\n      outline: 0;\r\n      box-shadow: 0 2px 6px -8px rgba($primary, 0.45);\r\n    }\r\n  }\r\n\r\n  button {\r\n    -webkit-appearance: none;\r\n    width: 100%;\r\n    max-width: 250px;\r\n    min-width: 100px;\r\n    border-radius: 0.25em;\r\n    text-align: center;\r\n    padding: 20px 40px;\r\n    margin: 10px 0;\r\n    background-color: $button-color;\r\n    color: $white;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    box-shadow: 0 2px 6px -1px rgba($black, 0.13);\r\n    border: none;\r\n    transition: all 0.3s ease;\r\n    outline: 0;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      transform: translateY(-3px);\r\n      box-shadow: 0 2px 6px -1px rgba($primary, 0.65);\r\n\r\n      &:active {\r\n        transform: scale(0.99);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n#ox-forgotpassword-form {\r\n  flex-grow: 0;\r\n  justify-content: space-between;\r\n  padding: 0;\r\n  padding-bottom: 20px;\r\n  height: auto;\r\n}\r\n\r\n.form-signin__footer {\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  flex-direction: column;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  font-size: 15px;\r\n  // gap: 10px;\r\n\r\n  button {\r\n    margin: 10px 0;\r\n  }\r\n\r\n  a {\r\n    margin: 15px 0;\r\n    color: $button-color;\r\n    text-decoration: none;\r\n\r\n    &:hover {\r\n      text-decoration: underline;\r\n    }\r\n  }\r\n}\r\n\r\n// Floating label\r\n.floating-label {\r\n  position: relative;\r\n  margin-bottom: 10px;\r\n  width: 100%;\r\n  padding: -5 px;\r\n}\r\n\r\n.form-filler {\r\n  width: 100;\r\n  height: 120px;\r\n}\r\n\r\n.footer-CR {\r\n  color: white;\r\n}\r\n.login .input-field > label {\r\n  user-select: none;\r\n}\r\n\r\n.login-copyright {\r\n  font-size: 12px;\r\n  color: #b3b3b3;\r\n  text-align: center;\r\n  padding: 0 16px;\r\n}\r\n\r\n#footer {\r\n  position: fixed;\r\n  bottom: 0;\r\n  width: 100%;\r\n  padding: 10px;\r\n  z-index: 10;\r\n  background-color: #452767;\r\n}\r\n\r\n.coppyRight{\r\n  color: #275362;\r\n  justify-content: center;\r\n}\r\n\r\n.osjs-login-error {\r\n  //background: #fae1dc;\r\n  color: #ff2b00;\r\n  //border-color: #fae1dc;\r\n  min-height: 24px;\r\n  font-size: 13px;\r\n  line-height: 1.23;\r\n  text-shadow: none;\r\n  position: relative;\r\n  padding: 4px;\r\n  margin-bottom: 1rem;\r\n  //border: 1px solid transparent;\r\n  //border-radius: 2px;\r\n}\r\n\r\n@media screen and (max-width: 900px) {\r\n  #ox-login-form {\r\n    text-align: center;\r\n    position: relative;\r\n    margin: 0px;\r\n    overflow: auto;\r\n    flex: 0 0 100%;\r\n    max-width: 500px;\r\n  }\r\n  .form-wrapper__inner {\r\n    padding: 30px;\r\n  }\r\n  .ox-imgDiv {\r\n    margin-bottom: 30px;\r\n  }\r\n  .loginSlider{\r\n    display: none!important;\r\n    // width: 100% !important;\r\n    // flex: 0 0 100% !important;\r\n    // max-width: 100% !important;\r\n  }\r\n  .loginContainer{\r\n    // flex-wrap: wrap-reverse !important;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.tooltip:hover .tooltiptext {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n.tooltip .tooltiptext {\r\n  visibility: hidden;\r\n  position: absolute;\r\n  width: 350px;\r\n  background-color: #555;\r\n  color: #fff;\r\n  text-align: left;\r\n  padding: 5px 5px;\r\n  border-radius: 6px;\r\n  z-index: 1;\r\n  opacity: 0;\r\n  transition: opacity 0.6s;\r\n  right: 10%;\r\n  top: -100%;\r\n}\r\n.tooltip-left {\r\n  top: -5px;\r\n  bottom: auto;\r\n  right: 128%;\r\n}\r\n\r\n.resetPasswordInputField {\r\n  display: inline-flex;\r\n\r\n  .newPasswordDiv {\r\n    display: inline;\r\n    width: 100%;\r\n  }\r\n\r\n  .infoDiv {\r\n    display: inline;\r\n    width: 10%;\r\n    margin: auto;\r\n    border-bottom: none;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n.passwordRestInfoIcon {\r\n  color: $white;\r\n  font-size: 1.5em;\r\n  border-radius: 10px;\r\n  background-color: $button-color;\r\n}\r\n\r\n// Footer styles\r\n.footer {\r\n  position: absolute;\r\n  display: flex;\r\n  bottom: 30px;\r\n  width: 100%;\r\n  flex-direction: column;\r\n}\r\n\r\n.footer-links {\r\n  // margin-bottom: 25px;\r\n  text-align: center;\r\n  // position: absolute;\r\n  // left: 0;\r\n  // bottom: 0;\r\n  // width: 100%;\r\n}\r\n\r\n.login-copyright {\r\n  font-size: 12px;\r\n  color: #b3b3b3;\r\n  text-align: center;\r\n  padding: 0 16px;\r\n}\r\n\r\n// Links\r\na {\r\n  &.footer-link {\r\n    color: $button-color;\r\n    text-decoration: dashed;\r\n  }\r\n\r\n  &.forgotpasswordLink {\r\n    margin: 15px;\r\n    color: $button-color;\r\n    border-bottom: 1px dotted $button-color;\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n// Announcement styles\r\n.Announcement-visuals {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  background-color: #edf3f2;\r\n  width: 100% !important;\r\n  position: absolute !important;\r\n  top: 0;\r\n\r\n  img {\r\n    width: auto;\r\n    height: auto;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n// Slider styles\r\n.announcement-slider {\r\n  position: relative;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n.slider-wrapper {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n  z-index: 10;\r\n}\r\n\r\n.slide {\r\n  position: unset;\r\n  display: inline-block;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n// Arrow navigation\r\n.arrowWrap {\r\n  flex-direction: row;\r\n  width: 100%;\r\n  height: 100%;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  top: 0;\r\n  position: absolute;\r\n\r\n  .arrow {\r\n    height: 50px;\r\n    width: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    transition: transform ease-in 0.1s;\r\n    opacity: 0.3;\r\n\r\n    &:hover {\r\n      opacity: 1;\r\n      background-color: $white;\r\n    }\r\n  }\r\n\r\n  .backArrow,\r\n  .nextArrow {\r\n    z-index: 100;\r\n    color: gray;\r\n    opacity: 0.3;\r\n    background-color: $white;\r\n  }\r\n\r\n  .backArrow {\r\n    margin-left: 1%;\r\n  }\r\n\r\n  .nextArrow {\r\n    margin-right: 1%;\r\n  }\r\n}\r\n\r\n// Tooltips\r\n.tooltip {\r\n  &:hover .tooltiptext {\r\n    visibility: visible;\r\n    opacity: 1;\r\n  }\r\n\r\n  .tooltiptext {\r\n    visibility: hidden;\r\n    position: absolute;\r\n    width: 350px;\r\n    background-color: $tooltip-bg;\r\n    color: $white;\r\n    text-align: left;\r\n    padding: 5px;\r\n    border-radius: 6px;\r\n\r\n    opacity: 0;\r\n    transition: opacity 0.6s;\r\n    right: 10%;\r\n    top: -100%;\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes shake-shake {\r\n  0% {\r\n    transform: translateX(-$displacement);\r\n  }\r\n\r\n  20% {\r\n    transform: translateX($displacement);\r\n  }\r\n\r\n  40% {\r\n    transform: translateX(-$displacement);\r\n  }\r\n\r\n  60% {\r\n    transform: translateX($displacement);\r\n  }\r\n\r\n  80% {\r\n    transform: translateX(-$displacement);\r\n  }\r\n\r\n  100% {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n// Media queries\r\n@media screen and (max-width: 900px) {\r\n  #ox-login-form {\r\n    text-align: center;\r\n    position: relative;\r\n    margin: 0;\r\n    overflow: auto;\r\n    flex: 0 0 100%;\r\n    max-width: 500px;\r\n  }\r\n\r\n  .form-wrapper__inner {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-evenly;\r\n    padding: 30px\r\n  }\r\n\r\n  // .ox-imgDiv {\r\n  //   margin-bottom: 30px;\r\n  // }\r\n\r\n  .loginSlider {\r\n    display: none !important;\r\n  }\r\n\r\n  .loginContainer {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n}}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
